const API_KEY = '242bc620';
const BASE_URL = 'https://www.omdbapi.com/';

/**
 * Search for movies by title
 * @param {string} query - Search query
 * @param {number} page - Page number for pagination
 * @returns {Promise<Object>} Search results
 */
export const searchMovies = async (query, page = 1) => {
    try {
        const response = await fetch(
            `${BASE_URL}?apikey=${API_KEY}&s=${encodeURIComponent(query)}&page=${page}`
        );
        const data = await response.json();

        if (data.Response === 'False') {
            throw new Error(data.Error || 'Failed to fetch movies');
        }

        return data;
    } catch (error) {
        console.error('Error searching movies:', error);
        throw error;
    }
};

/**
 * Get movie details by IMDb ID
 * @param {string} imdbID - IMDb ID of the movie
 * @returns {Promise<Object>} Movie details
 */
export const getMovieDetails = async (imdbID) => {
    try {
        const response = await fetch(
            `${BASE_URL}?apikey=${API_KEY}&i=${imdbID}&plot=full`
        );
        const data = await response.json();

        if (data.Response === 'False') {
            throw new Error(data.Error || 'Failed to fetch movie details');
        }

        return data;
    } catch (error) {
        console.error('Error fetching movie details:', error);
        throw error;
    }
};

/**
 * Get popular movies (using a predefined search)
 * @param {number} page - Page number
 * @returns {Promise<Object>} Popular movies
 */
export const getPopularMovies = async (page = 1) => {
    // Since OMDb doesn't have a "popular" endpoint, we'll search for common terms
    const popularSearches = ['marvel', 'star wars', 'batman', 'avengers', 'spider'];
    const randomSearch = popularSearches[Math.floor(Math.random() * popularSearches.length)];
    return searchMovies(randomSearch, page);
};
